import { Routes } from '@angular/router';


export const ErrorRoutes: Routes = [
  {
    path: 'miscellaneous/error',
    loadComponent: () => import('./404.component').then(m => m.ErrorComponent),
    title: '404 | ADROIT',
  },
];
